








































































































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import BulkFieldMapping from "@/components/BulkFieldMapping.vue";
import BulkQuestionare from "@/components/BulkQuestionare.vue";
import BulkCuratedUpload from "@/components/BulkCuratedUpload.vue";
import BulkUpload from "@/components/BulkUpload.vue";
import BulkCategory from "@/components/BulkCategory.vue";
import BulkProgress from "@/components/BulkProgress.vue";
import CompaniesSwitcher from "@/components/CompaniesSwitcher.vue";
@Component({
  components: {
    BulkUpload,
    BulkQuestionare,
    BulkCuratedUpload,
    BulkFieldMapping,
    BulkCategory,
    BulkProgress,
    CompaniesSwitcher,
  },
  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      if (from.name === "bulk_job_list") {
        vm.fromJobsList = true;
      }
    });
  },
})
export default class BulkJobCreate extends Vue {
  @Provide("$api") $api: any;
  @Provide("$_") $_: any;

  @Prop() private companyId!: string;
  @Prop() private accountId!: string;
  @Prop() private jobId!: string;
  @Prop() private step!: string;

  currentJobId = this.jobId || null;
  fromJobsList = false;

  stepsByRoles: any = {
    customerOrRepWithSupport: [
      "Upload product catalog",
      "Fill Questionare",
      "Review and create",
    ],
    customerOrRepWithoutSupport: [
      "Upload product catalog",
      "Fill Questionare",
      "Map columns",
      "Select profile/categories",
      "Review and create",
    ],
    expert: [
      "Upload product catalog",
      "Fill Questionare",
      "Upload curated catalog",
      "Map columns",
      "Select profile/categories",
      "Review and create",
    ],
  };

  steps: string[] = [];

  currentStep = Number(this.step) || 0;

  async created() {
    this.steps = await this.getSteps();
  }

  private backToAllJobs() {
    this.$router.push({
      path: `/classification/${this.accountId}/${this.companyId}/jobs`,
    });
  }

  updateJobId(jobId) {
    this.currentJobId = jobId;
  }

  async getSteps() {
    if (this.$store.state.herculeRole === "ClassificationInternalExpert") {
      return this.stepsByRoles.expert;
    } else {
      const isFullClassificationAdmin =
        this.$store.state.herculeRole === "ClassificationAdmin" &&
        this.$store.getters.featureLevel("item-classification") === "full";
      if (this.currentJobId && isFullClassificationAdmin) {
        this.$store.commit("startLoading");
        try {
          const response = await this.$api.get(
            `item-classification-api/v1/jobs/${this.companyId}/${this.currentJobId}`
          );
          const jobDetails = response.data;
          return jobDetails.metadata.support &&
            jobDetails.metadata.support == "true"
            ? this.stepsByRoles.customerOrRepWithSupport
            : this.stepsByRoles.customerOrRepWithoutSupport;
        } catch (error) {
          this.$store.commit("stopLoading");
          return this.stepsByRoles.customerOrRepWithoutSupport;
        }
      } else {
        return isFullClassificationAdmin
          ? this.stepsByRoles.customerOrRepWithoutSupport
          : this.stepsByRoles.customerOrRepWithSupport;
      }
    }
  }

  async nextStep() {
    this.steps = await this.getSteps();
    this.currentStep = this.currentStep + 1;
    this.fromJobsList = false;
    const query = Object.assign({}, this.$route.query);
    query.step = this.currentStep.toString();
    this.$router.push({ query });
  }

  async previousStep() {
    this.steps = await this.getSteps();
    this.currentStep = this.currentStep - 1;
    this.fromJobsList = false;
    const query = Object.assign({}, this.$route.query);
    query.step = this.currentStep.toString();
    this.$router.push({ query });
  }

  async gotoStep(step) {
    this.steps = await this.getSteps();
    this.currentStep = Number(step);
    this.fromJobsList = false;
    const query = Object.assign({}, this.$route.query);
    query.step = this.currentStep.toString();
    this.$router.push({ query });
  }

  companySwitched(event) {
    const params = Object.assign({}, this.$route.params, {
      companyId: event.companyId,
    });
    this.$router.push({ name: "bulk_job", params: params });
    location.reload();
  }

  showStepper() {
    //stepper to show only during job creation and not while visiting job summary
    return !(this.fromJobsList && this.currentStep === this.steps.length - 1);
  }
}
